import React from 'react';

function DeviceFrame({ src, alt }) {
  return (
    <div className="device">
      <div className="lid">
        <div className="cam" />
        <div className="scr">
          <img src={src} alt={alt} />
        </div>
      </div>
      <div className="base" />
    </div>
  );
}

export default DeviceFrame;
